import { Routes, Route } from "react-router-dom";
import DashboardPage from "@pages/DashboardPage";
import Login from "@pages/Login";
import Register from "@pages/Register";
import ForgotPassword from "@pages/ForgotPassword";
import NotFoundPage from "@pages/NotFoundPage";
import UsageAnalyticsPage from "@pages/UsageAnalyticsPage";
import EmailVerification from "../pages/EmailVerification";
import PrivateRoute from "./PrivateRoute";
import SuperAdminRoute from "./SuperAdminRoute";
import VerifyEmailRoute from "./VerifyEmailRoute";

// O Dashboard121Insights (v45) gerencia internamente sua própria navegação
// entre abas e sua própria sidebar/topbar. Por isso, não há AppLayout
// envolvendo a rota principal — o componente renderiza fullscreen.
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route
        path="/verify-email"
        element={
          <VerifyEmailRoute>
            <EmailVerification />
          </VerifyEmailRoute>
        }
      />

      <Route
        path="/"
        element={
          <PrivateRoute>
            <DashboardPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/admin/usage"
        element={
          <PrivateRoute>
            <SuperAdminRoute>
              <UsageAnalyticsPage />
            </SuperAdminRoute>
          </PrivateRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
